import { useMemo, useState } from 'react'
import { useGetEventUserQuery } from '../api/eventUser.api'
import { useGetMySettingsQuery } from '../api/v2/settings'
import { useMyContext } from '../context/context'
import useLanguagesV2 from './useLanguagesV2'
import { useSettingsV3 } from './useSettingsV3'

const useSettingsV2 = () => {
  // const [settingsPolling, setSettingsPolling] = useState(false)
  const { settings, isFetching } = useSettingsV3()
  // const { userLanguageId } = useLanguagesV2()

  // const context = useMemo(() => ({ ...(myContext || {}), ...(myContext2 || {}) }), [myContext, myContext2])

  // const { data: userEvent } = useGetEventUserQuery({ ...context })
  // const { data: settings, isSuccess, isFetching } = useGetMySettingsQuery(
  //   {
  //     languageId: userLanguageId,
  //     typoId: userEvent?.UserEvent?.typoId,
  //     ...context,
  //   },
  //   { pollingInterval: settingsPolling ? 5000 : 0 }
  // )

  // return { settings: settings || {}, isFetched: isSuccess, isFetching, settingsPolling, setSettingsPolling }
  return { settings: settings || {}, isFetching }
}

export default useSettingsV2
